/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, Button, Table } from "react-bootstrap";
import moment from "moment";
import CompletedJobItemList from "./show/CompletedJobItemList";
import JobViewItemList from "./JobViewItemList";
import JobAttachment from "./JobAttachment";
import Client from "../../Client";
import StatusHelper from "../StatusHelper";

const JobStartAtDisplay = ({ job }) => {
  const format = "D MMM YYYY h:mm A";
  const jobStartAt = job.startAt ? moment(job.startAt).format(format) : "";
  if (job.status === "COMPLETED") {
    const actualJobStartAt = job.actualStartAt
      ? moment(job.actualStartAt).format(format)
      : "";

    return actualJobStartAt;
  }

  return <span>{jobStartAt}</span>;
};
JobStartAtDisplay.propTypes = {
  job: PropTypes.object.isRequired
};

const JobEndAtDisplay = ({ job }) => {
  const format = "D MMM YYYY h:mm A";
  if (job.actualEndAt) {
    return (
      <tr>
        <td>End:</td>
        <td>{moment(job.actualEndAt).format(format)}</td>
      </tr>
    );
  }

  return <tr><td colSpan="2" /></tr>;
};
JobEndAtDisplay.propTypes = {
  job: PropTypes.object.isRequired
};

const AddressDisplay = ({ address }) => {
  const { number, street, suburb, postcode, state } = address;
  return (
    <span>
      {number} {street}, {suburb} {postcode} {state}
    </span>
  );
};
AddressDisplay.propTypes = {
  address: PropTypes.object.isRequired
};

class JobView extends Component {
  state = {
    fetched: false,
    job: {}
  };

  componentDidMount() {
    const { runsheetId, jobId } = this.props.match.params;
    Client.getJobDetails(runsheetId, jobId).then(job => {
      this.setState({ job, fetched: true });
    });
  }

  handleBackClick = () => {
    this.props.history.goBack();
  };

  handleViewAllRunsheets = () => {
    this.props.history.push("/runsheets");
  };

  render() {
    const { runsheetId } = this.props.match.params;

    if (this.state.fetched) {
      const job = this.state.job;
      const jobType = job.type === "PICKUP" ? "Pickup" : "Delivery";

      return (
        <div className="container-fluid">
          <div className="widget_header">
            <Row>
              <Col md={6}>
                <h4>Showing Job: {job.customerName}</h4>
              </Col>
              <Col md={6}>
                <div className="pull-right">
                  <Button onClick={this.handleBackClick}>BACK</Button>{" "}
                  <Button onClick={this.handleViewAllRunsheets}>
                    VIEW ALL RUNSHEETS
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <div>
            <Row>
              <Col md={6}>
                <Table>
                  <tbody>
                    <tr>
                      <td>Seq:</td>
                      <td>{job.seq}</td>
                    </tr>
                    <tr>
                      <td>Type:</td>
                      <td>{jobType}</td>
                    </tr>
                    <tr>
                      <td>Status:</td>
                      <td>{StatusHelper(job.status)}</td>
                    </tr>
                    <tr>
                      <td>Start:</td>
                      <td>
                        <JobStartAtDisplay job={job} />
                      </td>
                    </tr>
                    <JobEndAtDisplay job={job} />
                  </tbody>
                </Table>
              </Col>
              <Col md={6}>
                <Table className="job_content">
                  <tbody>
                    <tr>
                      <td>Customer Name:</td>
                      <td>{job.customerName}</td>
                    </tr>
                    <tr>
                      <td>Stop Seq:</td>
                      <td>{job.seq}</td>
                    </tr>
                    <tr>
                      <td>Location:</td>
                      <td>
                        <AddressDisplay address={job.stop.location.address} />
                      </td>
                    </tr>
                    <tr class="job_content_notes">
                      <td>Notes:</td>
                      <td>{job.notes}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>

          {job.status === "COMPLETED" ? (<CompletedJobItemList job={job} />) : (
            <Table bordered striped>
              <thead>
                <tr>
                  <th>Item ID</th>
                  <th>Item</th>
                  <th>Quantity</th>
                  <th>Delivery Status</th>
                </tr>
              </thead>
              <JobViewItemList job={job} jobItems={job.jobItems} />
            </Table>
          )}

          {job.jobAttachments.length ? (
            <Table bordered striped>
              <thead>
                <tr>
                  <th className="attachment">Attachment</th>
                  <th>Note</th>
                </tr>
              </thead>
              <JobAttachment runsheetId={runsheetId} jobId={job.id} />
            </Table>
          ) : (
              ""
            )}
        </div>
      );
    }
    return <div />;
  }
}
JobView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      runsheetId: PropTypes.string.isRequired,
      jobId: PropTypes.string.isRequired
    })
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func
  }).isRequired
};

export default JobView;



// WEBPACK FOOTER //
// ./src/components/jobs/JobView.js